
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BrandService } from '../../../../services/brand/brand.service';
import { SupplierService } from '../../../../services/supplier/supplier.service';

@Component({
  selector: 'app-supplier-brand-form',
  templateUrl: './supplier-brand-form.component.html',
  styles: ['label.required:after {top: 0}']
})
export class SupplierBrandFormComponent implements OnInit {

  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();

  addEditFormSupBrand: FormGroup;

  brand_items: Array<{value: number, label: string}>;
  selected_brand: any;

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    public supplierService: SupplierService,
    private svcBrand: BrandService) {
  }

  ngOnInit(): void {

    this.brand_items = sessionStorage.getItem('supplierBrands') ? JSON.parse(sessionStorage.getItem('supplierBrands')) : [{value: null, label: ''}];

    if (!sessionStorage.getItem('supplierBrands')) {
      this.svcBrand.getAll().subscribe(
        res => {
          this.svcBrand.brands.forEach(c => {
            this.brand_items.push({
              label: c.name,
              value: c.id
            })
          }
          );
        },
        error => console.error(error),
        () => sessionStorage.setItem('supplierBrands', JSON.stringify(this.brand_items))
      );
    }

    this.supplierService.getFieldsBrand().subscribe(res => {
      this.fields = res;
    });

    this.addEditFormSupBrand = this.fb.group({
      'brand_id': new FormControl(null)
    });

  }

  saveOrUpdate(): void {

    if (!this.addEditFormSupBrand.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    this.onAddElement.emit( {
      brand_id: this.selected_brand
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-brand/supplier-brand-form.component.ts